var isSeoTextTruncated = true;
function toggleIsTruncatedText(){
    const richTextDiv = document.getElementById("rich-text-text");
    const btn = document.getElementById("truncateBtn");
    
    if(isSeoTextTruncated){
        richTextDiv.classList.remove("rich-text__truncate");
        btn.innerText = "Read Less";
        isSeoTextTruncated = false;
    }
    else {
        richTextDiv.classList.add("rich-text__truncate");
        btn.innerText = "Read More";
        isSeoTextTruncated = true;
    }
}